import { render, staticRenderFns } from "./DashbordDropdown.vue?vue&type=template&id=872ca734&scoped=true&"
import script from "./DashbordDropdown.vue?vue&type=script&lang=js&"
export * from "./DashbordDropdown.vue?vue&type=script&lang=js&"
import style0 from "./DashbordDropdown.vue?vue&type=style&index=0&id=872ca734&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872ca734",
  null
  
)

export default component.exports